// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "definicao-extrema-57b68.firebaseapp.com",
  "projectId": "definicao-extrema-57b68",
  "storageBucket": "definicao-extrema-57b68.firebasestorage.app",
  "messagingSenderId": "457609522828",
  "appId": "1:457609522828:web:ca9f56a91265809d7295a9",
  "measurementId": "G-6S3B27X2T3",
  "apiKey": "AIzaSyByPjzm_xFsDkOmWM2UerhV9Or9Ezqphag"
};
